import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const StarHalfDashed = t0 => {
  const $ = _c(14);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M13.8062 5L12.8151 3.00376C12.4817 2.33208 11.5184 2.33208 11.1849 3.00376L10.6894 4.00188" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M15.011 7.427L15.4126 8.23599L16.8648 8.44704" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M19.7693 8.86914L21.2215 9.08019C21.9668 9.1885 22.2639 10.0994 21.7243 10.6219L20.6736 11.6394" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M18.5724 13.6743L17.5217 14.6918L17.7697 16.1292" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M18.2656 19.0039L18.5135 20.4413C18.6409 21.1797 17.8614 21.7427 17.1945 21.394L15.8959 20.715" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M10.4279 19.5L12 18.678L13.2986 19.357" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M5.67145 19.3689L5.48645 20.4414C5.35908 21.1797 6.13859 21.7428 6.80546 21.3941L7.65273 20.9511" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path d="M6.25259 16L6.47826 14.6917L5.78339 14.0188" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t9 = <path d="M3.69875 12L2.27575 10.6219C1.73617 10.0993 2.03322 9.18844 2.77852 9.08012L3.88926 8.9187" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t10 = <path d="M7 8.4666L8.58737 8.23591L9.39062 6.61792" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t10;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t1 = $[2];
    t10 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== props) {
    t11 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16" strokeWidth={1}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</IconWrapper>;
    $[12] = props;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
};
export { StarHalfDashed };